<template>
    <div class="grid-chat-window-contact" ref="gridChatWindowContact">
        <ChatWindow ref="chatWindow" :contact="_contact" :key="_contact._id" :style="{ width: chatWindowWidth }" />
        <UserInfoWidget
            :contact="_contact"
            :maxUserInfoWidgetWidth="maxUserInfoWidgetWidth"
            :minUserInfoWidgetWidth="minUserInfoWidgetWidth"
            @width="resizingUserInfoWidget"
            :disabled-resize="disabledResize"
        />
    </div>
</template>
<script>
import _ from "lodash";
import ChatWindow from "./ChatWindow.vue";
import UserInfoWidget from "./UserInfoWidget.vue";
import { mapState } from "vuex";

export default {
    name: "GridChatWindowContact",
    components: {
        UserInfoWidget,
        ChatWindow,
    },
    props: {
        disabledResize: {
            type: Boolean,
            default: false,
        },
        contactId: {
            type: String,
            default: "",
        },
        contact: {
            type: Object,
            default: () => ({}),
        },
        maxUserInfoWidgetWidth: {
            type: Number,
            default: 0,
        },
        minUserInfoWidgetWidth: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        ...mapState({
            cachedContacts: (state) => state.contact.cachedContacts,
        }),
        _contact() {
            return this.cachedContacts[this.contactId] || this.cachedContacts[this.contact?._id] || this.contact;
        },
    },
    data: () => ({
        chatWindowWidth: `calc(100%)`,
    }),
    methods: {
        resizingUserInfoWidget(width) {
            if (this.disabledResize) return;
            this.chatWindowWidth = `calc(100% - ${width}px)`;
            this.$emit("width", width);
        },
    },
};
</script>
<style lang="scss" scoped>
.grid-chat-window-contact {
    display: flex;
    width: 100%;
    height: 100%;
}
</style>
